/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Translations_CountInputs */



/**
* | output |
* | --- |
* | "Import {count} Translations" |
*
* @param {Import_Translations_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_translations_count = /** @type {((inputs: Import_Translations_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Translations_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importer ${i?.count} traductions`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Übersetzungen importieren`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importa ${i?.count} traduzioni`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импортировать ${i?.count} переводов`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importar ${i?.count} traducciones`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入 ${i?.count} 个翻译`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count}件の翻訳をインポート`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद आयात करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importar ${i?.count} traduções`)
	return /** @type {LocalizedString} */ (`Import ${i?.count} Translations`)
});